export const appConfig = {
  apiBaseUrl: "",
  supportPhone: ""
};

export async function loadAppConfig() {
  try {
    const response = await fetch("/appsettings.json", {
      cache: "no-cache"
    });

    if (!response.ok) {
      throw new Error(`Failed to load appsettings.json: ${response.status}`);
    }

    const config = await response.json();

    appConfig.apiBaseUrl = config.apiBaseUrl || "";
    appConfig.supportPhone = config.supportPhone || "";
  } catch (error) {
    console.error("Failed to load appsettings.json", error);
    appConfig.apiBaseUrl = "";
  }
}